<nav class="c-bottombar" aria-label="Navigation rapide">
  @for (item of items(); track item.id) {
    <a class="c-bottombar__link" [routerLink]="item.route" routerLinkActive="is-active">
      <i class="c-bottombar__icon {{ item.icon }}" aria-hidden="true"></i>
      <span class="c-bottombar__label">{{ (item.shortLabelKey || item.labelKey) | translate }}</span>
    </a>
  }
  <!-- Fixed "Plus" tab: opens the full menu (the launcher grid). -->
  <a class="c-bottombar__link" routerLink="/menu" routerLinkActive="is-active">
    <i class="c-bottombar__icon fa-solid fa-bars" aria-hidden="true"></i>
    <span class="c-bottombar__label">{{ 'MENU.more' | translate }}</span>
  </a>
</nav>
